const LineClamp = ({lines = 1, className = '', children}) => {
  return (
    <div
      className={className}
      style={{
        display: '-webkit-box',
        WebkitLineClamp: lines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden'
      }}
    >
      {children}
    </div>
  );
};

export default LineClamp;
